export default __webpack_public_path__ + "static/media/edit.9a49354a.svg";